import './createTaskForm.scss';

import { memo, ReactNode } from 'react';

type Props = {
  children: ReactNode;
  className?: string;
};

export const CreateTaskFormComponent = ({ children, className }: Props) => (
  <div className={`mm-create-task-form ${className}`}>{children}</div>
);

const CreateTaskForm = memo(CreateTaskFormComponent);

export { CreateTaskForm };
